const LongArrowIcon = ({ className }: { className?: string }) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M24.6666 17.1663H14.525L19.1833 12.508L18 11.333L11.3333 17.9997L18 24.6663L19.175 23.4913L14.525 18.833H24.6666V17.1663Z"
      fill="currentColor"
    />
  </svg>
);

export default LongArrowIcon;
